/* globals Knitiv */

export default class KformFileLabelController {
	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 */
	constructor($rootScope) {
		this.$rootScope = $rootScope;

		this.file = undefined;

		/** @type {boolean} */
		this.kds = this.$rootScope?.kds;
	}
}
